import { takeEvery, put, take } from 'redux-saga/effects';
import get from 'lodash/get';

import connectionConsts from '../chatConnection/constants';
import { LOGOUT_NOTIFICATIONS_ERRORS } from '../../constants/errors';
import * as logout from './logout';

function* expireSessionSagaWorker({ payload }) {
  const notificationErrorCode = get(payload, 'data.error.code');

  yield put({ type: logout.consts.SUCCEED });

  if (notificationErrorCode === LOGOUT_NOTIFICATIONS_ERRORS.ENTITY_EXCEPTION) {
    yield take(logout.consts.CLEAR);
    yield put({
      type: logout.consts.EXPIRED_ERROR,
      payload: notificationErrorCode,
    });
  }
}

export default function* expireSessionSaga() {
  yield takeEvery([connectionConsts.LOGOUT], expireSessionSagaWorker);
}



// WEBPACK FOOTER //
// ./src/redux/auth/expire-session-saga.js